<template>
  <div class="#">
    本を登録する
    <div class="input-field">
      <div class="input-group mb-3">
        <input
          type="text"
          class="form-control"
          placeholder="Enter target"
          aria-describedby="button-addon2"
          v-model="bookTitle"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary"
            type="button"
            id="button-addon2"
            v-on:click="fetchAPI"
          >
            検索
          </button>
        </div>
      </div>
    </div>
    <div class="candidate-wrapper">
      <p>{{ message }}</p>
      <div
        v-for="(candidate, index) in candidates"
        v-bind:key="index"
        class="candidate"
      >
        <div class="image-wrapper">
          <img v-bind:src="candidate.imageURL" :title="candidate.bookTitle" />
        </div>
        <div class="info-wrapper">
          <div class="book-info">
            {{ candidate.bookId }}
            <br />
            {{ candidate.bookTitle }}
            <br />
            {{ candidate.author }}
            <br />
            {{ candidate.category }}
            <br />
            {{ candidate.description }}
          </div>
          <div class="button-wrapper">
            <button
              class="btn btn-outline-success my-2 my-sm-0"
              v-on:click="markAsRead(index)"
            >
              読んだ！
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import { db } from "@/firebase";

export default {
  data: function() {
    return {
      message: "",
      bookTitle: "",
      author: "",
      category: "",
      description: "",
      imageURL: "",
      candidates: [
        // {
        //   bookTitle: "",
        //   author: "",
        //   category: "",
        //   description: "",
        //   imageURL: "",
        //   bookId: ""
        // }
      ]
    };
  },
  methods: {
    fetchAPI() {
      if (this.bookTitle) {
        this.message = "";
        this.candidates = [];
        fetch("https://www.googleapis.com/books/v1/volumes?q=" + this.bookTitle)
          .then(res => {
            return res.json();
          })
          .then(jsonData => {
            for (let i = 0; i <= jsonData.items.length; i++) {
              this.candidates.push({
                bookTitle: jsonData.items[i].volumeInfo.title,
                author: jsonData.items[i].volumeInfo.authors,
                category: jsonData.items[i].volumeInfo.categories,
                description: jsonData.items[i].volumeInfo.description,
                imageURL: jsonData.items[i].volumeInfo.imageLinks.thumbnail,
                bookId: jsonData.items[i].id
              });
              if (jsonData.items.length == 0) {
                this.message = "検索結果: 0件";
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
        this.bookTitle = "";
      }
    },
    markAsRead(i) {
      if (this.$store.getters.user.uid) {
        this.bookTitle = this.candidates[i].bookTitle;
        this.author = this.candidates[i].author;
        this.category = this.candidates[i].category;
        this.description = this.candidates[i].description;
        this.imageURL = this.candidates[i].imageURL;
        this.bookId = this.candidates[i].bookId;
        this.saveMyBook();
      } else {
        window.alert("ログインしてください");
      }
    },
    saveBook() {
      const bookRef = db.collection("books").doc(this.bookId);
      db.runTransaction(transaction => {
        return transaction.get(bookRef).then(doc => {
          console.log("in transaction ", doc.data());
          if (!doc.data()) {
            transaction.set(
              bookRef,
              {
                bookTitle: this.bookTitle || "",
                author: this.author || "",
                category: this.category || "",
                description: this.description || "",
                imageURL: this.imageURL || "",
                favCount: 1,
                createdAt: firebase.firestore.FieldValue.serverTimestamp()
              },
              { merge: true }
            );
          } else {
            transaction.update(bookRef, {
              favCount: firebase.firestore.FieldValue.increment(1),
              createdAt: firebase.firestore.FieldValue.serverTimestamp()
            });
          }
        });
      })
        .then(function() {
          console.log("Transaction successfully committed!");
          document.location.reload();
        })
        .catch(function(error) {
          console.log("Transaction failed: ", error);
        });
      db.collection("books")
        .doc(this.bookId)
        .set(
          {
            bookTitle: this.bookTitle || "",
            author: this.author || "",
            category: this.category || "",
            description: this.description || "",
            imageURL: this.imageURL || "",
            favCount: 1,
            createdAt: firebase.firestore.FieldValue.serverTimestamp()
          },
          { merge: true }
        )
        .then(() => {
          this.inputText = "";
        });
    },
    saveMyBook() {
      const books = this.$store.getters.user.books;
      // myBooksにまだない時
      if (!books.includes(this.bookId)) {
        books.push(this.bookId);
        this.$store.dispatch("updateUserData", { books: books });
        // booksコレクションに追加 or 更新
        this.saveBook();
        window.alert("mybookに登録しました！");
        // myBooksにすでにある時
      } else {
        window.alert("既にmybookに登録してあります。");
      }
    }
  }
};
</script>

<style lang="css">
.input-field {
  display: flex;
}
.candidate-wrapper {
  width: 100%;
  justify-content: center;
}
.candidate {
  width: 100%;
  border: 1px solid black;
  border-radius: 5px;
  margin: 10px 0;
  display: flex;
  background-color: #f8f9fa;
}
.image-wrapper {
  margin: 5px;
  padding: 10px;
}
.info-wrapper {
  margin: 10px;
  width: 100%;
  padding: 10px;
}
.book-info {
  width: 100%;
  border-radius: 5px;
  border: 1px solid rgb(180, 180, 180);
  background-color: white;
}
.button-wrapper {
  /* position: absolute;
  right: 0;
  bottom: 0; */
  margin-top: 20px;
  display: flex;
}
</style>
